// source: pbtypes/vehicle/skills/actions/register_complimentary_actions/register_complimentary_actions.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_vehicle_complimentary_actions_complimentary_actions_pb = require('../../../../../pbtypes/vehicle/complimentary_actions/complimentary_actions_pb.js');
goog.object.extend(proto, pbtypes_vehicle_complimentary_actions_complimentary_actions_pb);
goog.exportSymbol('proto.skills.RegisterComplimentaryActionsActionArgs', null, global);
goog.exportSymbol('proto.skills.RegisterComplimentaryActionsActionStateData', null, global);
goog.exportSymbol('proto.skills.RegisterComplimentaryActionsResultData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.RegisterComplimentaryActionsActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skills.RegisterComplimentaryActionsActionArgs.repeatedFields_, null);
};
goog.inherits(proto.skills.RegisterComplimentaryActionsActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.RegisterComplimentaryActionsActionArgs.displayName = 'proto.skills.RegisterComplimentaryActionsActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.RegisterComplimentaryActionsResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.RegisterComplimentaryActionsResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.RegisterComplimentaryActionsResultData.displayName = 'proto.skills.RegisterComplimentaryActionsResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.RegisterComplimentaryActionsActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.RegisterComplimentaryActionsActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.RegisterComplimentaryActionsActionStateData.displayName = 'proto.skills.RegisterComplimentaryActionsActionStateData';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skills.RegisterComplimentaryActionsActionArgs.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.RegisterComplimentaryActionsActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.RegisterComplimentaryActionsActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.RegisterComplimentaryActionsActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.RegisterComplimentaryActionsActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
complimentaryActionsToRegisterList: jspb.Message.toObjectList(msg.getComplimentaryActionsToRegisterList(),
    pbtypes_vehicle_complimentary_actions_complimentary_actions_pb.ComplimentaryAction.toObject, includeInstance),
timeoutS: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.RegisterComplimentaryActionsActionArgs}
 */
proto.skills.RegisterComplimentaryActionsActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.RegisterComplimentaryActionsActionArgs;
  return proto.skills.RegisterComplimentaryActionsActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.RegisterComplimentaryActionsActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.RegisterComplimentaryActionsActionArgs}
 */
proto.skills.RegisterComplimentaryActionsActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_vehicle_complimentary_actions_complimentary_actions_pb.ComplimentaryAction;
      reader.readMessage(value,pbtypes_vehicle_complimentary_actions_complimentary_actions_pb.ComplimentaryAction.deserializeBinaryFromReader);
      msg.addComplimentaryActionsToRegister(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTimeoutS(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.RegisterComplimentaryActionsActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.RegisterComplimentaryActionsActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.RegisterComplimentaryActionsActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.RegisterComplimentaryActionsActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplimentaryActionsToRegisterList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_vehicle_complimentary_actions_complimentary_actions_pb.ComplimentaryAction.serializeBinaryToWriter
    );
  }
  f = message.getTimeoutS();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * repeated complimentary_actions.ComplimentaryAction complimentary_actions_to_register = 1;
 * @return {!Array<!proto.complimentary_actions.ComplimentaryAction>}
 */
proto.skills.RegisterComplimentaryActionsActionArgs.prototype.getComplimentaryActionsToRegisterList = function() {
  return /** @type{!Array<!proto.complimentary_actions.ComplimentaryAction>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_vehicle_complimentary_actions_complimentary_actions_pb.ComplimentaryAction, 1));
};


/**
 * @param {!Array<!proto.complimentary_actions.ComplimentaryAction>} value
 * @return {!proto.skills.RegisterComplimentaryActionsActionArgs} returns this
*/
proto.skills.RegisterComplimentaryActionsActionArgs.prototype.setComplimentaryActionsToRegisterList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.complimentary_actions.ComplimentaryAction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.complimentary_actions.ComplimentaryAction}
 */
proto.skills.RegisterComplimentaryActionsActionArgs.prototype.addComplimentaryActionsToRegister = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.complimentary_actions.ComplimentaryAction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skills.RegisterComplimentaryActionsActionArgs} returns this
 */
proto.skills.RegisterComplimentaryActionsActionArgs.prototype.clearComplimentaryActionsToRegisterList = function() {
  return this.setComplimentaryActionsToRegisterList([]);
};


/**
 * optional float timeout_s = 2;
 * @return {number}
 */
proto.skills.RegisterComplimentaryActionsActionArgs.prototype.getTimeoutS = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.RegisterComplimentaryActionsActionArgs} returns this
 */
proto.skills.RegisterComplimentaryActionsActionArgs.prototype.setTimeoutS = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.RegisterComplimentaryActionsResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.RegisterComplimentaryActionsResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.RegisterComplimentaryActionsResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.RegisterComplimentaryActionsResultData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.RegisterComplimentaryActionsResultData}
 */
proto.skills.RegisterComplimentaryActionsResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.RegisterComplimentaryActionsResultData;
  return proto.skills.RegisterComplimentaryActionsResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.RegisterComplimentaryActionsResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.RegisterComplimentaryActionsResultData}
 */
proto.skills.RegisterComplimentaryActionsResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.RegisterComplimentaryActionsResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.RegisterComplimentaryActionsResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.RegisterComplimentaryActionsResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.RegisterComplimentaryActionsResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.RegisterComplimentaryActionsActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.RegisterComplimentaryActionsActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.RegisterComplimentaryActionsActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.RegisterComplimentaryActionsActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.RegisterComplimentaryActionsActionStateData}
 */
proto.skills.RegisterComplimentaryActionsActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.RegisterComplimentaryActionsActionStateData;
  return proto.skills.RegisterComplimentaryActionsActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.RegisterComplimentaryActionsActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.RegisterComplimentaryActionsActionStateData}
 */
proto.skills.RegisterComplimentaryActionsActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.RegisterComplimentaryActionsActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.RegisterComplimentaryActionsActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.RegisterComplimentaryActionsActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.RegisterComplimentaryActionsActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.skills);
